import Branch from './ab-test-branch';
import Shield from './ab-test-shield';
import Base from './ab-test-base';

export default { Branch, Shield, Base };
